import { Map, List, fromJS } from 'immutable';

export function update(state, action) {
    if (!action.data.id) {
        action.data.id = action.id;
    }

    return bulk(
        state,
        {
            data: [
                action.data
            ]
        }
    );
}

export function bulk(state, action) {
    let items = state.get('items');

    action.data.forEach((participant) => {
        let item = items.get(+participant.id) || Map();

        items = items.set(+participant.id, item.merge(participant));
    });

    return state.set('items', items);
}

export function addToSportCollection( state, { sportId, participant } ) {
    const items = state.getIn( [ 'collections', sportId, 'items' ], List() ).push( fromJS( participant ) );
    return state.setIn( [ 'collections', sportId, 'items' ], items );
}
